module.exports = __webpack_public_path__ + "img/Banner-SkyBuildings.ec4b9529.jpg";